import { render } from "./PlanningComponent.vue?vue&type=template&id=32a471aa"
import script from "./PlanningComponent.vue?vue&type=script&lang=js"
export * from "./PlanningComponent.vue?vue&type=script&lang=js"

import "./PlanningComponent.vue?vue&type=style&index=0&id=32a471aa&lang=scss"

import exportComponent from "/home/runner/work/schFront/schFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__